import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M18.1,6.5h-7.2c-2.4,0-4.4,2-4.4,4.4v7.2c0,2.4,2,4.4,4.4,4.4h7.2c2.4,0,4.4-2,4.4-4.4v-7.2 C22.4,8.5,20.5,6.5,18.1,6.5z M19.4,18.1c0,0.8-0.6,1.4-1.4,1.4h-7.2c-0.7,0-1.4-0.6-1.4-1.4v-7.2c0-0.8,0.6-1.4,1.4-1.4h7.2 c0.7,0,1.4,0.6,1.4,1.4V18.1z M18.1,25.6h-7.2c-2.4,0-4.4,2-4.4,4.4v7.2c0,2.4,2,4.4,4.4,4.4h7.2c2.4,0,4.4-2,4.4-4.4v-7.2 C22.4,27.5,20.5,25.6,18.1,25.6z M19.4,37.1c0,0.8-0.6,1.4-1.4,1.4h-7.2c-0.7,0-1.4-0.6-1.4-1.4v-7.2c0-0.8,0.6-1.4,1.4-1.4h7.2 c0.7,0,1.4,0.6,1.4,1.4V37.1z M37.1,6.5h-7.2c-2.4,0-4.4,2-4.4,4.4v7.2c0,2.4,2,4.4,4.4,4.4h7.2c2.4,0,4.4-2,4.4-4.4v-7.2 C41.5,8.5,39.5,6.5,37.1,6.5z M38.5,18.1c0,0.7-0.6,1.4-1.4,1.4h-7.2c-0.8,0-1.4-0.6-1.4-1.4v-7.2c0-0.7,0.6-1.4,1.4-1.4h7.2 c0.8,0,1.4,0.6,1.4,1.4V18.1z M37.1,25.6h-7.2c-2.4,0-4.4,2-4.4,4.4v7.2c0,2.4,2,4.4,4.4,4.4h7.2c2.4,0,4.4-2,4.4-4.4v-7.2 C41.5,27.5,39.5,25.6,37.1,25.6z M38.5,37.1c0,0.8-0.6,1.4-1.4,1.4h-7.2c-0.8,0-1.4-0.6-1.4-1.4v-7.2c0-0.8,0.6-1.4,1.4-1.4h7.2 c0.8,0,1.4,0.6,1.4,1.4V37.1z';
var filledPath = 'M29.9235 6.5C27.5158 6.5 25.5639 8.45186 25.5639 10.8596V18.0766C25.5639 20.4843 27.5158 22.4362 29.9235 22.4362H37.1405C39.5482 22.4362 41.5 20.4843 41.5 18.0766V10.8596C41.5 8.45186 39.5482 6.5 37.1405 6.5H29.9235ZM10.8596 6.50014C8.45185 6.50014 6.50002 8.452 6.50002 10.8597V18.0767C6.50002 20.4845 8.45185 22.4363 10.8596 22.4363H18.0766C20.4843 22.4363 22.4361 20.4845 22.4361 18.0767V10.8597C22.4361 8.452 20.4843 6.50014 18.0766 6.50014H10.8596ZM10.8596 25.5638C8.45183 25.5638 6.5 27.5157 6.5 29.9234V37.1404C6.5 39.5481 8.45183 41.5 10.8596 41.5H18.0765C20.4843 41.5 22.4361 39.5481 22.4361 37.1404V29.9234C22.4361 27.5157 20.4843 25.5638 18.0765 25.5638H10.8596ZM29.9235 25.5638C27.5158 25.5638 25.564 27.5157 25.564 29.9234V37.1404C25.564 39.5481 27.5158 41.5 29.9235 41.5H37.1405C39.5482 41.5 41.5001 39.5481 41.5001 37.1404V29.9234C41.5001 27.5157 39.5482 25.5638 37.1405 25.5638H29.9235Z';
var ToolsIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
ToolsIcon.displayName = 'ToolsIcon';
ToolsIcon.defaultProps = {
  'aria-label': 'Tools'
};
export default ToolsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ToolsIcon/index.js
// module id = 1961
// module chunks = 12